export const viewHelpGuide = (guideId) => ({
  type: "HELP_GUIDE_VIEW",
  payload: guideId,
});

export const toggleHelpGuideBookmark = (guideId) => ({
  type: "HELP_GUIDE_TOGGLE_BOOKMARK",
  payload: guideId,
});

export const setHelpGuideSearch = (query) => ({
  type: "HELP_GUIDE_SET_SEARCH",
  payload: query,
});
